export const CUSTOM_EVENTS = {
  ON_LOCATION_RESET: 'onLocationReset',
  ON_QUESTIONNAIRE_OPEN: 'onQuestionnaireOpen',
  ON_QUESTIONNAIRE_CLOSE: 'onQuestionnaireClose',
}

export function subscribeEvent(
  eventName: string,
  listener: () => void,
): void {
  document.addEventListener(eventName, listener)
}

export function unsubscribeEvent(
  eventName: string,
  listener: () => void,
): void {
  document.removeEventListener(eventName, listener)
}

export function publishEvent(eventName: string, data?: any): void {
  const event = new CustomEvent(eventName, { detail: data })
  document.dispatchEvent(event)
}
